import React, {Component} from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Button} from 'primereact/components/picklist/../button/Button';
import ObjectUtils from 'primereact/components/picklist/../utils/ObjectUtils';

export class PickListTransferControls extends Component {

    static defaultProps = {
        source: null,
        target: null,
        sourceSelection: null,
        targetSelection: null,
        onTransfer: null
    }

    static propsTypes = {
        source: PropTypes.array,
        target: PropTypes.array,
        sourceSelection: PropTypes.array,
        targetSelection: PropTypes.array,
        onTransfer: PropTypes.array
    }

    constructor(props) {
        super(props);
        this.moveDown = this.moveDown.bind(this);
        this.moveAllDown = this.moveAllDown.bind(this);
        this.moveUp = this.moveUp.bind(this);
        this.moveAllUp = this.moveAllUp.bind(this);
    }

    moveDown(event) {
        let selection = this.props.sourceSelection;

        if (!Array.isArray(selection)) {
            selection = [selection];
        }

        if(selection && selection.length) {
            let targetList = [...this.props.target];
            let sourceList = [...this.props.source];

            for(let i = 0; i < selection.length; i++) {
                let selectedItem = selection[i];

                if(ObjectUtils.findIndexInList(selectedItem, targetList) === -1) {
                    targetList.push(sourceList.splice(ObjectUtils.findIndexInList(selectedItem, sourceList), 1)[0]);
                }
            }

            if(this.props.onTransfer) {
                this.props.onTransfer({
                    originalEvent: event,
                    source: sourceList,
                    target: targetList,
                    direction: 'toTarget'
                })
            }
        }
    }

    moveAllDown(event) {
        if(this.props.source) {
            let targetList = [...this.props.target, ...this.props.source];
            let sourceList = [];

            if(this.props.onTransfer) {
                this.props.onTransfer({
                    originalEvent: event,
                    source: sourceList,
                    target: targetList,
                    direction: 'allToTarget'
                })
            }
        }
    }

    moveUp(event) {
        let selection = this.props.targetSelection;

        if (!Array.isArray(selection)) {
            selection = [selection];
        }

        if(selection && selection.length) {
            let targetList = [...this.props.target];
            let sourceList = [...this.props.source];

            for(let i = 0; i < selection.length; i++) {
                let selectedItem = selection[i];

                if(ObjectUtils.findIndexInList(selectedItem, sourceList) === -1) {
                    sourceList.push(targetList.splice(ObjectUtils.findIndexInList(selectedItem, targetList), 1)[0]);
                }
            }

            if(this.props.onTransfer) {
                this.props.onTransfer({
                    originalEvent: event,
                    source: sourceList,
                    target: targetList,
                    direction: 'toSource'
                })
            }
        }
    }

    moveAllUp(event) {
        if(this.props.source) {
            let sourceList = [...this.props.source, ...this.props.target];
            let targetList = [];

            if(this.props.onTransfer) {
                this.props.onTransfer({
                    originalEvent: event,
                    source: sourceList,
                    target: targetList,
                    direction: 'allToSource'
                })
            }
        }
    }

    render() {
        const children = React.Children.map(this.props.children, (child) => {
            return <child.type {...{...child.props, disabled: this.props.disabled || props.disabled}} />;
        });
        let className = classNames('picklist-control text-center', this.props.className);

        // <Button type="button" icon="pi pi-angle-double-right" onClick={this.moveAllDown}></Button>
        // <Button type="button" icon="pi pi-trash" onClick={this.moveAllUp}></Button>

        return <div className={className}>
            {this.props.sourceButton !== false && this.props.visible && <Button type="button" icon={classNames("pi pi-angle-down", {"disabled": this.props.disabled})} disabled={this.props.disabled || false} onClick={(e) => !this.props.disabled && this.moveDown(e)} />}
            {this.props.targetButton !== false && this.props.visible && <Button type="button" icon={classNames("pi pi-angle-up", {"disabled": this.props.disabled})} disabled={this.props.disabled || false} onClick={(e) => !this.props.disabled && this.moveUp(e)} />}
            {children}
        </div>;
    }
}

export default PickListTransferControls;